<template>
  <div class="containter">
    <lx-header></lx-header>
    <el-row type="flex" class="row-1" justify="space-between">
      <!-- 模式化状态评估 -->
      <el-col :span="12">
        <el-row :gutter="20">
          <el-col :span="14">
            <div class="title">【当前班组模式化状态评估】</div>
          </el-col>
          <el-col :span="5">
            <div class="title">当前班组：{{ resultData.curGroup }}</div>
          </el-col>
          <el-col :span="5">
            <div class="title">综合分：{{ resultData.score }}</div>
          </el-col>
        </el-row>
      </el-col>
      <!-- 模式化状态统计 -->
      <el-col :span="12">
        <div class="title">【班组模式化状态统计】</div>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-2" justify="space-between">
      <el-col :span="12">
        <!-- 状态评估 -->
        <el-row type="flex" justify="space-between">
          <el-col :span="24">
            <div class="panel statusAssessment">
              <div class="table">
                <el-table
                  :data="resultData.modelIndexData"
                  height="250px"
                  style="width: 100%; background: transparent"
                  :header-cell-style="{
                    color: 'white',
                    textAlign: 'center',
                    fontSize: '20px',
                  }"
                  :cell-style="{ color: 'white', textAlign: 'center',fontSize: '18px',height: '44px' }"
                >
                  <el-table-column
                    prop="modelName"
                    label="模型名称"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="conInd"
                    label="模式工况指数"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="stableInd"
                    label="稳定指数"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="optInd"
                    label="优化指数"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                </el-table>
              </div>
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="11">
                  <div class="linechart">
                    <lx-linechart :optionData="linechart"></lx-linechart>
                  </div>
                </el-col>
                <el-col :span="11">
                  <div class="radarChart">
                    <lx-radarChart :optionData="resultData.radarChartData"></lx-radarChart>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <!-- 监控状态统计 -->
          <el-col :span="16">
            <div class="panel monitoringStatus">
              <el-row>
                <div class="title">监控状态统计</div>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <div>总数：{{ resultData.runStateInfo.allModelNum }}</div>
                </el-col>
                <el-col :span="6">
                  <div>在线：{{ resultData.runStateInfo.onLineNum }}</div>
                </el-col>
                <el-col :span="6">
                  <div>离线：{{ resultData.runStateInfo.offLineNum }}</div>
                </el-col>
                <el-col :span="4">
                  <div>系统状态</div>
                </el-col>
                <el-col :span="2">
                  <div :class="resultData.runStateInfo.sysStatus == 1 ? 'green' : 'yellow'"></div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <div>正常：{{ resultData.runStateInfo.normalNum }}</div>
                </el-col>
                <el-col :span="6">
                  <div>预警：{{ resultData.runStateInfo.warnNum }}</div>
                </el-col>
                <el-col :span="6">
                  <div>报警：{{ resultData.runStateInfo.alarmNum }}</div>
                </el-col>
                <el-col :span="4">
                  <div>通讯状态</div>
                </el-col>
                <el-col :span="2">
                  <div :class="resultData.runStateInfo.comStatus == 1 ? 'green' : 'yellow'"></div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <!-- 报表预览 -->
          <el-col :span="8">
            <div class="panel reportPreview" @click="goReportPreview()">
              报表预览
            </div>
          </el-col>
        </el-row>
      </el-col>
      <!-- 柱状图 -->
      <el-col :span="12">
        <div class="panel statusStatistics">
          <div class="bar">
            <lx-bar :barData="bar1"></lx-bar>
          </div>
          <div class="bar">
            <lx-bar :barData="bar2"></lx-bar>
          </div>
          <div class="bar">
            <lx-bar :barData="bar3"></lx-bar>
          </div>
          <div class="bar">
            <lx-bar :barData="bar4"></lx-bar>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-footer style="height: 80px">
      <div class="menu">
        <el-button type="text" @click="goHome()">首页</el-button>
      </div>
    </el-footer>
  </div>
</template>

<script>
import { groupEvaluation , getPublicConfig } from "@/api/wormBox"
export default {
  data() {
    return {
      bar1: {
        text: "综\n合\n评\n估",
        title: true,
        values: [100, 56, 45, 67],
        names: ["一班", "二班", "三班", "四班"],
      },
      bar2: {
        text: "模\n式\n工\n况\n指\n数\n评\n估",
        title: true,
        values: [45, 56, 45, 67],
        names: ["一班", "二班", "三班", "四班"],
      },
      bar3: {
        text: "稳\n定\n指\n数\n评\n估",
        title: true,
        values: [100, 56, 45, 67],
        names: ["一班", "二班", "三班", "四班"],
      },
      bar4: {
        text: "优\n化\n指\n数\n评\n估",
        title: true,
        values: [23, 56, 45, 67],
        names: ["一班", "二班", "三班", "四班"],
      },
      linechart: {
        title:true,
        name: ["模式工况指数", "稳定指数","综合分"],
        yAxisIndex:[0],
        xtime: [1650722239000, 1689226848000, 1689226548000, 1689226748000],
        data1: ["5", "7", "13", "8"],
        data: ["10", "30", "50", "90"],
        data2: ["50", "10", "80", "40"],
        y: false,
        left: "-4%",
        right: "30%",
        min: -2,
        max: 14,
        interval: 2,
        orient: "vertical",
        legendY: "center",
        legendX: "70%",
        xInterval: 70,
        spacing: "15%",
        y0Min: -10,
        y0Max: 110,
        y0Interval: 30,
      },
      resultData:{
        curGroup:"甲",
        score:98,
        modelIndexData:[
          {
            modelName: "R001",
            conInd: "90",
            stableInd:"90",
            optInd: "90"
          },
          {
            modelName: "R002",
            conInd: "90",
            stableInd:"90",
            optInd: "90"
          },
          {
            modelName: "R003",
            conInd: "90",
            stableInd:"90",
            optInd: "90"
          }
        ],
        radarChartData:{
          values:[90.5,78,68],
          name: "甲",
        },
        runStateInfo:{
          sysStatus:1,
          comStatus:0,
          allModelNum:0,
          offLineNum:0,
          onLineNum:0,
          normalNum:0,
          warnNum:0,
          alarmNum:0
        }
      },
      // 传参数
      params:{
        startTime:null,
        endTime:null,
        workShopName:""
      },
      timerId: null
    };
  },
  methods: {
    defaultTime(timeStamp) {
      let tm = new Date(timeStamp);
      let y = tm.getFullYear();
      let mon = tm.getMonth() + 1;
      let d = tm.getDate();
      let hh = (tm.getHours() + "").padStart(2, 0);
      let ii = (tm.getMinutes() + "").padStart(2, 0);
      let ss = (tm.getSeconds() + "").padStart(2, 0);
      return `${y}/${mon}/${d}\n${hh}:${ii}:${ss}`;
    },
    timeX() {
      this.linechart.xtime = this.linechart.xtime.map((item) => {
        return (item = this.defaultTime(item));
      });
    },
    goReportPreview() {
      this.$router.push({path:"/ReportMail",query:{homePage:this.$route.query.homePage}})
    },
    goHome(){
      this.$router.push({path:`/${this.$route.query.homePage}`,query:{homePage:this.$route.query.homePage , index:0}})
    },
    async getData(){
      //数据赋值给resultData
      //趋势图、柱状图单独赋值
      //Body参数,开始和结束时间传null
      // {
      //     "workShopName": "PVC",
      //     "endTime": null,
      //     "startTime": null
      // }
      this.params.workShopName = this.$route.query.homePage
      const {code , resultData} =  await groupEvaluation(this.params)
      if(code == "200"){
        //console.log(resultData)
        this.resultData = resultData
        this.bar1 = {...this.bar1 , ...resultData.comprehEvalBarData}
        this.bar2 = {...this.bar2 , ...resultData.conBarData}
        this.bar3 = {...this.bar3 , ...resultData.stableBarData}
        this.bar4 = {...this.bar4 , ...resultData.optBarData}
        this.linechart.xtime = resultData.dateTime
        this.linechart.data = resultData.conLine
        this.linechart.data1 = resultData.stableline
        this.linechart.data2 = resultData.scoreLine
        this.linechart.xInterval =  Math.round(this.linechart.xtime.length/2)
        this.timeX()
      }
    },
     // 定时器方法
     startTimer() {
      // 启动定时器，每秒执行一次计数
      this.timerId = setInterval(() => {
        this.getData()
        this.getPublicData()
      }, 3000);
    },
    stopTimer() {
      // 停止定时器
      clearInterval(this.timerId);
    },
    async getPublicData(){
      const {code , resultData} =await getPublicConfig()
        if(code == "200"){
          this.linechart.y0Min = resultData.comprehEvalScoreLowerLimit
          this.linechart.y0Max = resultData.comprehEvalScoreHighLimit
          this.linechart.y0Interval =Math.round( (this.linechart.y0Max - this.linechart.y0Min) / 4 )
      }
    },
  },
  created() {
    this.getData()
    // this.getPublicData()
  },
  mounted(){
    this.startTimer()
  },
  destroyed(){
    this.stopTimer()
  }
};
</script>

<style lang="less" scoped>
.containter {
  color: white;
  height: 920px;
  width: 1920px;
  background: url(../assets/imgs/bg.jpg) no-repeat center / cover;
  .row-1 {
    padding-top: 40px;
    .title {
      font-size: 24px;
      text-align: center;
    }
  }
  .row-2 {
    .table {
      margin-bottom: 60px;
      /deep/ .el-table__body-wrapper::-webkit-scrollbar {
        width: 0;
      }
      /deep/ .el-table th {
        background-color: transparent !important;
      }
      /deep/ .el-table tr,
      .el-table td {
        background-color: transparent !important;
      }
      /deep/ .el-table tbody tr:hover > td {
        background-color: rgb(24, 43, 129);
      }
      /deep/ .el-table .el-table__cell {
        padding: 0.2vw 0;
        border: 0;
      }
      .el-table::before {
        height: 0;
      }
    }
    .statusStatistics {
      height: 758px;
      .bar {
        height: 185px;
      }
    }
    .statusAssessment {
      height: 585px;
      .linechart , .radarChart{
        height: 250px;
      }
    }
    .reportPreview {
      text-align: center;
      font-size: 24px;
      cursor: pointer;
      padding: 41px 0;
    }
    .monitoringStatus {
      font-size: 20px;
      height: 113px;
      .title{
        font-size: 24px;
        text-align: center;
        margin-bottom: 20px;
      }
      .yellow{
        background: yellow;
        width: 20px;
        height: 20px;
        border-radius: 100%;
        margin: 5px 0;
      }
      .green{
        background: greenyellow;
        width: 20px;
        height: 20px;
        border-radius: 100%;
        margin: 5px 0;
      }
    }
  }
  .el-footer{
    width: 100%;
    background: url(../assets/imgs/titleBottom.png) no-repeat top center;
    background-size: 100% 100%;
    white-space: nowrap;
    overflow: hidden;
    color: white;
    margin-top: 31px;
    .menu{
            text-align: center;
            .el-button {
                font-size: 28px;
                color: white;
                margin-top: 28px;
            }
            .el-button :hover {
              color: rgba(163, 163, 231, 0.747);
            }
        }
  }
}
</style>

